import React from "react";
import "./NoEffortReason.scss";
import { Button, Divider } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export default function NoEffortReason(props) {
  const styles = {
    button: {
      justifyContent: "space-between",
      color: "ButtonText",
    },
  };
  return (
    <div
      className="NoEffortReason margAll10"
      data-testid="NoEffortReason"
      key={"no_effort_trip_reason_div"}
    >
      {props.no_effort_trip_reason.map((reason) => (
        <div key={"reason_div_" + reason.KEY}>
          <Divider />
          <Button
            id={reason.KEY}
            key={"reason_" + reason.KEY}
            type="submit"
            fullWidth
            style={styles.button}
            className="form-input"
            data-new-value={reason.KEY}
            data-client-id={props.client_id}
            data-trip-id={props.trip_id}
            data-field={"no-effort-reason"}
            size="large"
            onClick={(e) => props.handleClick(e, props.action)}
            endIcon={<NavigateNextIcon key={"icon_" + reason.KEY} />}
          >
            {reason.VALUE}
          </Button>
        </div>
      ))}
      {props.no_effort_trip_reason.length > 0 && <Divider />}
    </div>
  );
}
